<template>
    <v-card>
        <!--
        @link https://v2.vuetifyjs.com/en/components/toolbars/
        -->
        <template v-if="heading">
            <v-toolbar flat>
                <v-toolbar-title>{{ heading }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!hideSearch" icon @click="search = !search">
                    <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="!hideFilter" icon @click="filter = !filter">
                    <v-icon>mdi-filter</v-icon>
                </v-btn>
                <v-btn v-if="!!$listeners['click:reload']" icon @click="$emit('click:reload')">
                    <v-icon>mdi-reload</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
        </template>
        <div class="pa-0">
            <slot v-bind="{search, filter}"/>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'VBaseCard',
    props: {
        heading: {
            type: String,
            default: '',
        },
        hideFilter: {
            type: Boolean,
        },
        hideSearch: {
            type: Boolean,
        },
    },
    data: () => ({
        search: false,
        filter: false,
    }),
    methods: {}
}
</script>